import { db } from "@/api/firebase";
import { Game } from "@/models/Game";
import { QuestWarning } from "@/models/Errors/QuestWarning";
import { Quests } from "@/models/MapPois/Quest/Quests";
import { isEmpty, isEqual, omit, toArray } from "lodash";
export default class QuestPoiWarnings {
  questData: Quests;
  gameUid: string;
  gameData: Game[];
  warningObject = {} as QuestWarning;

  constructor(gameUid: string, questData: Quests, gameData: Game[]) {
    this.questData = questData;
    this.gameUid = gameUid;
    this.gameData = gameData;
  }

  async checkQuestWarningErrors(): Promise<QuestWarning> {
    await this.checkIfTemplateIsDifferent();
    if (!isEmpty(this.warningObject)) {
      db.ref(
        "quests/" + this.gameUid + "/" + this.questData.key + "/issues/warn/"
      ).set(this.warningObject);
    } else {
      db.ref(
        "quests/" + this.gameUid + "/" + this.questData.key + "/issues/warn/"
      ).remove();
    }
    return this.warningObject;
  }

  private async checkIfTemplateIsDifferent(): Promise<void> {
    const currentGame = this.gameData.find((x: Game) => x.key == this.gameUid);
    if (currentGame !== undefined && currentGame.clone_parent !== undefined) {
      const templateGame = this.gameData.find(
        (x: Game) => x.key == currentGame.clone_parent
      );
      if (templateGame !== undefined && templateGame.template) {
        await db
          .ref("quests/" + templateGame.key + "/" + this.questData.key)
          .once("value", (results) => {
            const result = results.val() as Quests;
            const quest = this.questData;
            if (!isEqual(omit(quest, ["issues"]), omit(result, ["issues"]))) {
              this.warningObject.quest_difference = {
                active: true,
                txt: {
                  en: "This quest differs from the Original Template",
                },
              };
            }
          });
      } else {
        currentGame.clone_parent = "";
        await db.ref("games/" + currentGame.key).set(currentGame);
      }
    }
  }
}
